export const WHY_WE_RENT = [
  {
    title: 'Используем продвижение объявления в топ',
    description: 'С платным размещением объявление получает больше просмотров и целевых звонков',
    imgClass: 'ok',
  },
  {
    title: 'Не теряем просмотры',
    description:
      'Все желающие могут посмотреть квартиру в любое удобное время. Больше показов — быстрее сдадим квартиру',
    imgClass: 'lens',
  },
  {
    title: 'Экономим ваше время',
    description:
      'Если вы не можете присутствовать на встрече — мы сможем подписать договор онлайн. На всё — не больше 15 минут',
    imgClass: 'calendar',
  },
];
